import { render, staticRenderFns } from "./DashboardProjects.vue?vue&type=template&id=8ba11af2&"
import script from "./DashboardProjects.vue?vue&type=script&lang=js&"
export * from "./DashboardProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports